import React from 'react'

function Dummy() {
  return (
    <div className="page-content-wrapper mt-0">
      <div className="container mt-4">
        <div style={{ marginTop: "4rem" }}>

          {/* <div className="card mb-2" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-12 rounded-4"></span>
              </h5>
              <p className="card-text d-flex justify-content-between placeholder-glow">
                <span className="placeholder col-2 rounded-3 py-2"></span>
                <span className="placeholder col-2 rounded-3 py-2"></span>
                <span className="placeholder col-2 rounded-3 py-2"></span>
                <span className="placeholder col-2 rounded-3 py-2"></span>
              </p>
            </div>
          </div> */}

          <ul className="card">
            <li className="placeholder-glow col-3 d-block d-flex flex-column p-1">
              <span className="placeholder bg-primary col-1 d-block mb-2 rounded-1"></span>
              <span className="placeholder bg-primary col-1 d-block rounded-1"></span>
            </li>
            <li className="placeholder-glow col-3 d-block d-flex flex-column p-1">
              <span className="placeholder bg-primary col-1 d-block mb-2 rounded-1"></span>
              <span className="placeholder bg-primary col-1 d-block rounded-1"></span>
            </li>
            <li className="placeholder-glow col-3 d-block d-flex flex-column p-1">
              <span className="placeholder bg-primary col-1 d-block mb-2 rounded-1"></span>
              <span className="placeholder bg-primary col-1 d-block rounded-1"></span>
            </li>
            <li className="placeholder-glow col-3 d-block d-flex flex-column p-1">
              <span className="placeholder bg-primary col-1 d-block mb-2 rounded-1"></span>
              <span className="placeholder bg-primary col-1 d-block rounded-1"></span>
            </li>
          </ul>

        </div>
      </div>
    </div>
  )
}

export default Dummy